export const breakPoints = {
  high_resolution: 1600,
  desktop_large: 1200,
  desktop: 920,
  tablet: 768,
  mobile: 576,
  mobile_s: 320,
};
